import React, { useCallback } from 'react'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BlueButton from 'components/inputs/BlueButton'
import { TOneItemCallback } from 'HttpRequests'
import { IProductBase } from 'product/IProduct'
import { Col } from 'react-bootstrap'

interface ISelectProductActionsProps {
  product: IProductBase
  isLoading: boolean
  onAddToCart: TOneItemCallback<IProductBase>
}

const SelectProductActions: React.FC<ISelectProductActionsProps> = ({
  product,
  isLoading,
  onAddToCart,
}) => {
  const handleAddProduct = useCallback(() => {
    onAddToCart(product)
  }, [product, onAddToCart])

  return (
    <>
      <Col xs={5} md={8} className='d-flex align-items-center'>
        <div className='big-font'>{product.price}&nbsp;₽ </div>
      </Col>
      <Col xs={7} md={4} className='text-right'>
        <BlueButton
          onClick={handleAddProduct}
          className='link-no-brake'
          disabled={isLoading}
        >
          <FontAwesomeIcon icon={faShoppingCart} className='mx-1' />
          Купить
        </BlueButton>
      </Col>
    </>
  )
}
export default SelectProductActions
